'use client'

import { useEffect, useState } from 'react'
import { readConsent, grantConsent, denyConsent } from '@/lib/analytics/consent'
import { getAnalytics } from '@/lib/analytics/client'

export function ConsentBanner() {
  const [show, setShow] = useState(false)
  useEffect(() => { setShow(readConsent() === 'unset') }, [])
  if (!show) return null

  const accept = () => {
    grantConsent()
    // Capture the current page now — the initial load fired pre-consent as a no-op, so it
    // would otherwise be lost. getAnalytics() inits posthog (consent is now granted).
    getAnalytics().pageview(window.location.origin + window.location.pathname)
    setShow(false)
  }

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 border-t bg-background/95 backdrop-blur px-4 py-3 shadow-lg">
      <div className="mx-auto flex max-w-4xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground">
          We use privacy-friendly analytics to improve Papr. No tracking until you agree.{' '}
          <a href="/privacy" className="underline">Learn more</a>.
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => { denyConsent(); setShow(false) }}
            className="rounded-md border px-3 py-1.5 text-sm"
          >Decline</button>
          <button
            onClick={accept}
            className="rounded-md bg-primary px-3 py-1.5 text-sm text-primary-foreground"
          >Accept</button>
        </div>
      </div>
    </div>
  )
}
